import { render, staticRenderFns } from "./hiVideo.vue?vue&type=template&id=e0ff4504&"
import script from "./hiVideo.vue?vue&type=script&lang=js&"
export * from "./hiVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports